var _Loading, _PausedCaptureOverlay;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { View } from '@instructure/ui-view';
import * as CaptureActions from '../../../actions';
import { STARTING, LOADING, ERROR, READY, PAUSED, PREVIEWSAVE } from '../../../constants/CaptureStates';
import { DeviceError } from '../../../constants/DeviceError';
import CountdownTimer from '../CountdownTimer';
import Loading from '../Loading';
import Message from '../Message';
import PausedCaptureOverlay from '../PausedCaptureOverlay';
import NoInputOverlay from '../NoInputOverlay';

/**
---
private: true
---
**/
function MediaOverlay({
  captureState,
  msg,
  actions,
  hasInputStream,
  isNoSystemPermissionLayout,
  systemPermissionsLink
}) {
  var _Message, _CountdownTimer, _NoInputOverlay;
  const getOverlay = () => {
    switch (captureState) {
      case LOADING:
        return _Loading || (_Loading = /*#__PURE__*/React.createElement(Loading, null));
      case ERROR:
        return _Message || (_Message = /*#__PURE__*/React.createElement(Message, {
          msg: msg
        }));
      case STARTING:
        return _CountdownTimer || (_CountdownTimer = /*#__PURE__*/React.createElement(CountdownTimer, {
          actions: actions
        }));
      case READY:
        return !hasInputStream ? _NoInputOverlay || (_NoInputOverlay = /*#__PURE__*/React.createElement(NoInputOverlay, {
          noSystemPermission: isNoSystemPermissionLayout,
          systemPermissionsLink: systemPermissionsLink
        })) : null;
      case PAUSED:
        return _PausedCaptureOverlay || (_PausedCaptureOverlay = /*#__PURE__*/React.createElement(PausedCaptureOverlay, null));
      default:
        return null;
    }
  };
  return captureState !== PREVIEWSAVE ? /*#__PURE__*/React.createElement(View, {
    as: "div",
    position: "absolute",
    insetInlineStart: "0",
    insetInlineEnd: "0",
    insetBlockStart: "0",
    insetBlockEnd: "0"
  }, getOverlay()) : null;
}
const mapStateToProps = state => ({
  captureState: state.captureState,
  msg: state.msg,
  hasInputStream: state.audioDeviceId || state.videoDeviceId || state.screenSharingActive,
  isNoSystemPermissionLayout: state.noSystemPermissionDevices.has(DeviceError.Webcam) && state.noSystemPermissionDevices.has(DeviceError.Mic)
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(CaptureActions, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(MediaOverlay);